/**
 * Testimonial-related actions
 */
(function ($) {
    'use strict';

    $(function () {
        var model = 'settings';
        var a_ajax = new AwesomeAjax('aet');
        var aet_ajax = new AET_Ajax();

        function settings_open_callback() {
            window.preview = new AwesomeSettings();
            preview.init();
        }
        function settings_close_callback() {
            if(typeof preview != 'undefined'){
                preview.destroy();
            }
        }

        // settings panel
        $('#action-settings').on('click', function () {
            var args = {
                id: 'aet',
                item_id: '#',
                parent: '#wpcontent',
                html: '#settings-wrap',
                model_name: 'settings',
                direction: 'right',
                width: '67%',
                callback_open: settings_open_callback,
                callback_close: settings_close_callback
            };
            window.settings_panel = new AwesomePanel(args);
            settings_panel.init();
        });

        // Bind AJAX call on Form Submit Button
        $('[data-action="save-settings"]').on('click', function () {
            var form = $('[data-type="form"]', aet_panel);
            var $alert = form.find('[data-type="settings-alert"]');
            $alert.attr('class', 'alert').hide();

            window.settings_panel.hide_content();
            window.settings_panel.animation_start(); // show animation

            a_ajax.ajax({
                action: 'aet_update_' + model,
                data: {
                    data: window.settings_model.toJSON()
                },
                success_handler: function (data) {
                    window.settings_panel.show_content();
                    window.settings_panel.animation_end();
                },
                success_error_handler: function (errors) {
                    var html = '';
                    $.each(errors, function (index, value) {
                        html += '<p>';
                        html += value.message;
                        html += '</p>';
                    });
                    $alert.addClass('alert-warning').show().html(html);
                    window.settings_panel.show_content();
                    window.settings_panel.animation_end();
                },
                error_handler: function () {
                    $alert.addClass('alert-warning').show().html(data);
                    window.settings_panel.show_content();
                    window.settings_panel.animation_end();
                }
            });
        });
    });
})(jQuery);